exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect--active .multiselect__select[data-v-2a01e9bc]{transform:rotate(180deg);bottom:15px}.multiselect__select[data-v-2a01e9bc]:before{content:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a01e9bc","scoped":true,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/general/LocaleSwitcher.vue
// module id = mGHf
// module chunks = 0 1